import { Card, CardBody, Col } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import CommonCardHeader from "../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader";
import { LI, UL } from "../../../AbstractElements";
import { monthlyDropdownList, studyStatisticsChart } from "../../../Data/Dashboard/Default";

const Analysis = () => {
  return (
    <Col xl="5" md="6" className="xl-60 box-col-7">
      <Card>
        <CommonCardHeader headClass="pb-0 card-no-border" mainTitle dropDownList={monthlyDropdownList} title={"Statistical Analysis"} />
        <CardBody className="pe-0">
          <div className="studay-statistics">
            <UL className="d-flex align-item-center gap-2 simple-list flex-row">
              <LI>
                <span className="bg-primary"> </span>Web Design
              </LI>
              <LI>
                <span className="bg-secondary"> </span>Flutter App
              </LI>
            </UL>
          </div>
          <ReactApexChart
            options={studyStatisticsChart}
            series={studyStatisticsChart.series}
            type="area"
            height={320}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default Analysis;
